import React, { FC } from 'react';

const LinkIcon: FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 0H15.5C15.75 0 16 0.25 16 0.5V5.5C16 5.78125 15.75 6 15.5 6C15.2188 6 15 5.78125 15 5.5V1.71875L7.34375 9.375C7.15625 9.5625 6.8125 9.5625 6.625 9.375C6.4375 9.1875 6.4375 8.84375 6.625 8.65625L14.2812 1H10.5C10.2188 1 10 0.78125 10 0.5C10 0.25 10.2188 0 10.5 0ZM2 2H6.5C6.75 2 7 2.25 7 2.5C7 2.78125 6.75 3 6.5 3H2C1.4375 3 1 3.46875 1 4V14C1 14.5625 1.4375 15 2 15H12C12.5312 15 13 14.5625 13 14V9.5C13 9.25 13.2188 9 13.5 9C13.75 9 14 9.25 14 9.5V14C14 15.125 13.0938 16 12 16H2C0.875 16 0 15.125 0 14V4C0 2.90625 0.875 2 2 2Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LinkIcon;
